/**
 * In dev, requests go through Vite's `/api` proxy → http://localhost:4000.
 * In a built deployment, override with VITE_API_URL.
 */
export const API_BASE_URL: string =
  (import.meta.env['VITE_API_URL'] as string | undefined) ?? '/api';
